import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { createElement } from 'react';
import { Text, Icons, styled } from '@/theme/index';

const Wrapper = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  marginTop: theme.spacing(2.5),
}));

const Header = styled(Text)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  fontWeight: 'bold',
  textAlign: 'center',

  [theme.breakpoints.up('sm')]: {
    textAlign: 'left',
  },
}));

const Container = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  display: 'flex',
  gap: theme.spacing(2.5),
  width: '100%',
  flexDirection: 'column',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

const HowItWorksStep = styled('div')(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(1),
}));

const StyledIcon = (
  icon: OverridableComponent<SvgIconTypeMap<Record<string, unknown>, 'svg'>> & {
    muiName: string;
  }
) =>
  styled(icon)(({ theme }) => ({
    width: '25px',
    height: '25px',
    color: `${theme.palette.primary.main}`,
    display: 'none',

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  }));

export function UnclaimedMoneyHowItWorks() {
  return (
    <Wrapper>
      <Header variant="h5">How Unclaimed Money Search Works</Header>
      <Container>
        <HowItWorksStep>
          <Text variant="h5" marginBottom="0">
            How it goes unclaimed
          </Text>
          <Text variant="body2">
            If a business owes you money but can't get in contact with you, they
            may turn the money over to your state government
          </Text>
        </HowItWorksStep>
        {createElement(StyledIcon(Icons.ArrowForward))}
        <HowItWorksStep>
          <Text variant="h5" marginBottom="0">
            Where it is held
          </Text>
          <Text variant="body2">
            Many states protect unclaimed money and hold it until it is claimed
            by the rightful owner
          </Text>
        </HowItWorksStep>
        {createElement(StyledIcon(Icons.ArrowForward))}
        <HowItWorksStep>
          <Text variant="h5" marginBottom="0">
            Finding it
          </Text>
          <Text variant="body2">
            Since there is no centralized process for claiming this money, we
            help you search many state records in one place
          </Text>
        </HowItWorksStep>
        {createElement(StyledIcon(Icons.ArrowForward))}
        <HowItWorksStep>
          <Text variant="h5" marginBottom="0">
            Recovering it
          </Text>
          <Text variant="body2">
            If you find money that belongs to you, we'll direct you to the
            official state process for filing a claim to get that money back
          </Text>
        </HowItWorksStep>
      </Container>
    </Wrapper>
  );
}
